import { render, staticRenderFns } from "./KSelectItem.vue?vue&type=template&id=8f54a82c&scoped=true&"
import script from "./KSelectItem.vue?vue&type=script&lang=js&"
export * from "./KSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./KSelectItem.vue?vue&type=style&index=0&id=8f54a82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f54a82c",
  null
  
)

export default component.exports